import { ActionReducerMapBuilder } from "../../../common/redux/createReducer";
import { InteropStore, RootStore } from "../types";
import { StoreType } from "../store";
import { createAction, PayloadAction } from "@reduxjs/toolkit";
import Logger from "../../../clients/logger";

const getInitialState = (): RootStore => {
	return {
		isVisible: false,
		heartbeats: true,
		testing: {
			unitTestingEnabled: false,
			messagesToSend: [],
			dispatchesToSend: [],
			selectConnectChannelMessagesToSend: [],
			destinationsBeforeSelectConnect: [],
			triggeredRules: [],
			error: "",
		},
	};
};

const actions = {
	windowVisible: createAction<boolean>("root/windowVisible"),
	toggleHeartbeats: createAction<void>("root/toggleHeartbeats"),
};

const addReducerCases = (builder: ActionReducerMapBuilder<InteropStore>) => {
	builder.addCase(actions.windowVisible, (state, action: PayloadAction<boolean>) => {
		const isVisible = action.payload;
		state.root.isVisible = isVisible;
		Logger.log("interopService.root.windowVisible", state.resolver, action);
	});

	builder.addCase(actions.toggleHeartbeats, (state) => {
		state.root.heartbeats = !state.root.heartbeats;
	});
};

export default {
	getInitialState,
	addReducerCases,
	actions,
	initialize: (store: StoreType) => {},
};
